export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11629.9c40c5d0.jpg";